import { Dialog, DialogContent } from "../ui/dialog";
import { Loader2, Check, Database, Play } from "lucide-react";

function ExecutingCompsetModal({ isExecuting, step, maxStep = 2 }) {
    const steps = [
        { icon: Database, label: "Fetching information" },
        { icon: Play, label: "Executing compset" },
    ];

    return (
        <Dialog open={isExecuting} onOpenChange={() => { }}>
            <DialogContent
                className="max-w-md [&>button]:hidden"
                onPointerDownOutside={(e) => e.preventDefault()}
                onEscapeKeyDown={(e) => e.preventDefault()}
                data-testid="compset-execution-progress"
            >
                <div className="py-6 text-center">
                    {/* Animated icon */}
                    <div className="relative mx-auto w-20 h-20 mb-6">
                        <div
                            className="absolute inset-0 rounded-full bg-primary/10 animate-ping"
                            style={{ animationDuration: "2s" }}
                        />
                        <div className="relative w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
                            {step < maxStep ? (
                                <Loader2 className="w-8 h-8 text-primary animate-spin" />
                            ) : (
                                <Check className="w-8 h-8 text-primary" />
                            )}
                        </div>
                    </div>

                    <h3 className="text-xl font-semibold mb-2">
                        {step < maxStep ? "Executing Compset" : "Execution Complete"}
                    </h3>

                    <p className="text-sm text-muted-foreground mb-8">
                        {step < maxStep
                            ? "Please wait while we process your compset..."
                            : "Redirecting to results..."}
                    </p>

                    {/* Steps */}
                    <div className="space-y-3 text-left max-w-xs mx-auto">
                        {steps.map((item, i) => (
                            <div key={i} className="flex items-center gap-3">
                                <div
                                    className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-500 ${i < step
                                            ? "bg-primary text-primary-foreground"
                                            : i === step
                                                ? "bg-primary/20 text-primary"
                                                : "bg-muted text-muted-foreground"
                                        }`}
                                >
                                    {i < step ? (
                                        <Check className="w-3.5 h-3.5" />
                                    ) : (
                                        <item.icon className="w-3.5 h-3.5" />
                                    )}
                                </div>

                                <span
                                    className={`text-sm transition-colors duration-300 ${i < step
                                            ? "text-foreground font-medium"
                                            : i === step
                                                ? "text-foreground"
                                                : "text-muted-foreground"
                                        }`}
                                >
                                    {item.label}
                                </span>

                                {i === step && i < maxStep && (
                                    <Loader2 className="w-3.5 h-3.5 animate-spin text-primary ml-auto" />
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Progress bar */}
                    <div className="mt-8 w-full bg-muted rounded-full h-1.5 overflow-hidden">
                        <div
                            className="h-full bg-primary rounded-full transition-all duration-700 ease-out"
                            style={{ width: `${Math.min((step / maxStep) * 100, 100)}%` }}
                        />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default ExecutingCompsetModal;